'use client';

import { BasicModal, TextButton } from 'components';
import { Row } from 'styles';
import { useFetchPrivacy } from '../modules';

interface PrivacyModalProps {
  open: boolean;
  onClose: () => void;
}

export const PrivacyModal: React.FC<PrivacyModalProps> = ({ open, onClose }) => {
  const { data: privacy } = useFetchPrivacy();

  if (!privacy) {
    return <div></div>;
  }

  return (
    <BasicModal
      header="Privacy Statement"
      width={900}
      height={500}
      open={open}
      onClose={onClose}
      body={<div dangerouslySetInnerHTML={{ __html: privacy }} />}
      footer={
        <Row>
          <TextButton label={'OK'} onClick={onClose} />
        </Row>
      }
    />
  );
};
